import { AssetClass } from '@/entities/assets'

import { TRANSACTION_TYPE } from '@/entities/transactions/utils/const'

import { WizardValues } from '../utils/types'
import { createHolding, createMarks, ensureOwnerAccount, ensureTagIds } from '../utils/create'

/** Same string the legacy Fine art and collectables wizard files pieces under. */
const PIECE_TYPE = 'fine art and collectables'

/**
 * One piece, hanging off the account the ownership step named.
 *
 * The account is created only when the user asked for a new one — the step's
 * two halves, resolved by `ensureOwnerAccount`. This flow used to create an
 * account on every run, which meant a second "Sotheby's" for every piece bought
 * through the same one.
 */
export const create = async (values: WizardValues): Promise<AssetClass[]> => {
  const tagIds = await ensureTagIds(values.tags)
  const accountId = await ensureOwnerAccount(values)

  const piece = await createHolding({
    accountId,
    transactionType: TRANSACTION_TYPE.ADD_POSITION,
    name: values.assetName,
    type: PIECE_TYPE,
    currency: values.currency,
    description: values.description,
    amount: values.amount,
    date: values.date,
    tagIds,
  })

  /*
   * After the holding, because a price needs the asset it is a price of. An
   * empty list is the normal case — the valuation step is optional, and most
   * pieces are entered with nothing but what they cost.
   */
  await createMarks(piece.id, values.prices)

  return [piece]
}
